import { Capacitor } from '@capacitor/core';

// Is this the web version (Owner decision list 2026-10-19 item 45) — a browser on a computer, not the iPhone /
// Android app? A built site in a browser always is. The development server and the tests also run in a browser
// but stand in for the APP (store screenshots, QA lanes, the app's tests), so there the web version's own
// behaviour (web purchase lane and prices, e-mail-code sign-in instead of Apple / Google, the "only in this
// browser" notice) is switched on only with `localStorage['yanwushi-dev:web'] = '1'`.
export const DEV_WEB_KEY = 'yanwushi-dev:web';

export function devWebVersionWanted(): boolean {
  try {
    return import.meta.env.DEV && window.localStorage.getItem(DEV_WEB_KEY) === '1';
  } catch {
    return false;
  }
}

export function webVersionUi(): boolean {
  if (Capacitor.isNativePlatform()) return false;
  return !import.meta.env.DEV || devWebVersionWanted();
}
